import { useConfig } from "../../../contexts/ConfigContext"
import React, { useEffect, useState } from "react"
import { Button, message, Select, TableColumnsType } from "antd"
import TableView from "../TableView"
import useAuth from "../../../hooks/useAuth"
import { ColumnType } from "antd/es/table"
import { SearchOutlined } from "@ant-design/icons"
import { useCompany } from "../../../contexts/CompanyContext"
import { useCashRegisterFetch, usePosFetch, useSessionCashFetch } from "../../../hooks/useSale"
import { TPos, usePos } from "../../../contexts/PosContext"
import { useSession } from "../../../contexts/CashSessionContext"
import fetchDataService from "../../../services/fetchDataService"
import CashSessionModal from "../../modals/CashSessionModal"
import { useCashRegister } from "../../../contexts/CashRegisterContext"
import { formatDateTime } from "../../../utils"

function getStatusLabel(status: string){
  if(status==="OPEN"){
    return "Creado"
  }
  if(status==="CLOSED"){
    return "Finalizado"
  }
  if(status==="STARTED"){
    return "Iniciado"
  }
  if(status==="LOCKED"){
    return "Bloqueado"
  }
  return "Sin estado"
}

function ViewCashSessionList(){
  const { config } = useConfig()
  const {session,updateSession} = useSession()
  const {pos,updatePos} = usePos()
  const {company} = useCompany()
  const {cashRegister,updateCashRegister} = useCashRegister()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:posData} = usePosFetch(tokenData,{
    all:true,
    company:company.current.uid,
  },company.current.id)
  const uidPos = pos.currentSelected?.uid ? pos.currentSelected.uid : posData?.pos?.length ? posData.pos[0].uid : ""
  const {data} = useSessionCashFetch(tokenData,posData,{
    all:true,
    company:company.current.uid,
    uidPos
  })
  const {data:registerData} = useCashRegisterFetch(tokenData,{
    all:true,
    company:company.current.uid,
    uidPos
  })
  useEffect(()=>{
    if(data?.cashSession){
      updateSession({list: data.cashSession})
    }
    if(posData?.pos?.length){
      const currentSelected = pos.currentSelected?.uid ? pos.currentSelected : posData.pos[0]
      updatePos({list:posData.pos,currentSelected})
    }
    if(data || posData){
      setSkeleton(false)
    }
    if(registerData?.cashRegisterList?.length){
      updateCashRegister({list: registerData.cashRegisterList})
    }
  },[data,posData,registerData])
  //console.log('Load content ',companies.current)
  let title = 'Sesiones para ' + (pos.currentSelected?.name || "Punto de venta")
  let emptyMessage = 'Aun no has agregado sesiones en este PDV'

  const handleClick = async (data:any,index:any) => {
    setSpinning(true)
    updateSession({showModal:true,current:data})
    setSpinning(false)
  }

  // Columnas de la tabla con búsqueda
  const filterIconElement = (filtered:boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  const getColumnSearchProps = (dataIndex: string): ColumnType => ({
    /*
    filterDcurrentropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters,confirm)} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </Space>
      </div>
    ),*/
    filterIcon: filterIconElement,
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toString().toLowerCase())
  });

  const tableColumns:TableColumnsType = [
    {title: "#",dataIndex:"register",width:50},
    {title: "Inicio",dataIndex:"created_at",render:(text)=>formatDateTime(text),
      sorter:(a,b)=>a.name.localeCompare(b.name),
      ...getColumnSearchProps('created_at')},
    {title: "Cajero",dataIndex:"cashier_name",ellipsis:true,
      sorter:(a,b)=>a.description.localeCompare(b.description),
      ...getColumnSearchProps('cashier_name')},
    {title: "Autoriza",dataIndex:"opened_by_name",ellipsis:true,
      sorter:(a,b)=>a.description.localeCompare(b.description),
      ...getColumnSearchProps('opened_by_name')},
    {title: "Estado",dataIndex:"tableStatus"},
  ]

  const dataTable = session?.list?.map((el,i)=>{
    const register = i + 1
    const key = i 
    const tableStatus = getStatusLabel(el.status)
    return {...el,register,key,tableStatus}
  })
  const handleButtonClick = () => {
    if(cashRegister?.list?.length === 0){
      message.error('Debe registrar antes una caja')
      return
    }
    updateSession({showModal:true,current:undefined})
  }
  const handleSelect = async (option:string) => {
    setSpinning(true)
    const selectedPos = pos.list.find(el => el.uid === option) as TPos
    updatePos({currentSelected:selectedPos})
    const sessionResponse = await fetchDataService.post('/sale/cash-session/get-session',config.key,{
      company: company.current.uid,
      all: true,
      uidPos: option
    })
    if(sessionResponse.status === 200){
      updateSession({list: sessionResponse.cashSession})
    }
    setSpinning(false)
  }
  const footerElement = () => <Button type="primary" onClick={handleButtonClick} htmlType="button">Crear Sesión</Button>
  const headerElement = () => <Select onSelect={handleSelect} value={pos.currentSelected?.uid} style={{width:"100%"}}>
    {pos.list.map(el => <Select.Option key={el.uid} value={el.uid}>{el.name}</Select.Option>)}
  </Select>
  return (
    <TableView
      title={title}
      spinning={spinning}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      headerElement={headerElement}
      modal={CashSessionModal}
      footerElement={footerElement}
      onRow={(data:any,index:any) => {return{onClick:()=>handleClick(data,index),style:{cursor:"pointer"}}}}
      emptyMessage={emptyMessage}>
    </TableView>
  )
}

export default ViewCashSessionList